export const DEFAULT_SCREEN_DEVICE_ID = 'default';

/**
 * Sentinel camera-selector value that turns the camera off instead of switching
 * to a device. Used by screen recording, where the camera bubble is optional.
 */
export const CAMERA_OFF_DEVICE_ID = '__camera_off__';

export type MediaRecorderState = MediaRecorder['state'];

export const CANVAS_CAPTURE_STREAM_FPS = 30;
export const CANVAS_DEFAULT_WIDTH = 1920;
export const CANVAS_DEFAULT_HEIGHT = 1080;

export const CANVAS_MAX_WIDTH = 1920;
export const CANVAS_MAX_HEIGHT = 1080;

export type DeviceInfo = {
    label: string;
    id: string;
};

export enum DeviceTypes {
    AUDIO = 'audio',
    VIDEO = 'video',
    SCREEN = 'screen',
}

export type DeviceInfoForDeviceType = {
    [DeviceTypes.AUDIO]: DeviceInfo[];
    [DeviceTypes.VIDEO]: DeviceInfo[];
    [DeviceTypes.SCREEN]: DeviceInfo[];
};

export enum RecordingType {
    AUDIO = 'audio',
    VIDEO = 'video',
}

export enum MimeType {
    CHROME_OPERA_AUDIO_MIME_TYPE = 'audio/webm',
    FIREFOX_AUDIO_MIME_TYPE = 'audio/ogg',
    SAFARI_AUDIO_MIME_TYPE = 'audio/mp4',
    CHROME_VIDEO_MIME_TYPE = 'video/webm',
    FIREFOX_VIDEO_MIME_TYPE = 'video/webm',
    SAFARI_VIDEO_MIME_TYPE = 'video/mp4',
}

export type DeviceConstraint = {
    audio?: Record<any, any>;
    video?: Record<any, any>;
};

export enum RECORD_MODAL_STATE {
    START = 'start',
    UNSUPPORTED = 'unsupported',
    PERMISSION_DENIED = 'denied',
    SETUP = 'setup',
    READY = 'ready',
    COUNTDOWN = 'countdown',
    RECORDING = 'recording',
    PAUSED = 'paused',
    FINISH_RECORDING = 'finish_recording',
}

export enum SCREEN_RECORDING_SOURCE {
    SLIDE_LIST = 'slide_list',
    APP_FLOW = 'app_flow',
}
